module.exports = "/assets/data/06322c4dbd2f6fff4129c5fbae2e17ba-HP8.data.json";